import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "reactstrap";
import CommercialLgCard from "../../components/cards/CommercialLgCard";
import CommercialSmCard from "../../components/cards/CommercialSmCard";
import ItemsCard2 from "../../components/cards/ItemsCard2";
import Header from "../../components/globals/Header";
import SearchBar from "../../components/inputs/SearchBar";
import AddCommercialModal from "../../components/modals/AddCommercialModal";
import {
  dummyNearYouPlaces,
  dummyRecentCommercials
} from "../../dummyData";
import { useUserCommericalHooks } from "../../hooks/useUserCommericalHooks";
import { useTranslation } from "../../languages";
import { useDeviceLocation } from "../../hooks/utilityHooks";
import { calculateDistanceKm } from "../../utils";
const UserCommercials = () => {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const user = useSelector((s) => s?.user ?? {});
  const { t } = useTranslation();
  console.log("user data is>>>", user);
  const {
    //all local states
    allCommercialData,
  } = useUserCommericalHooks();

  const { location } = useDeviceLocation(true);
  const [filteredCommercials,setFilteredCommercials]=useState([]);
  const [searchValue,setSearchValue]=useState("");


  const placesNear = useMemo(() => {

    return [...(allCommercialData ?? [])]?.filter((item) => {
      let commercialCoordinates = item?.place?.location?.coordinates;

      let userCoordinates = { lat: location?.latitude, lng: location?.longitude };

      let distance = calculateDistanceKm
        ([userCoordinates?.lat, userCoordinates?.lng],
          [commercialCoordinates?.lat, commercialCoordinates?.lng]
        );

      return distance <= 40;

    })

  }, [allCommercialData, location]);

  const mostPopular = useMemo(() => {
    if (!allCommercialData?.length) return [];

    return [...allCommercialData]
      .filter((item) => Array.isArray(item?.views) && item?.views?.length > 0)
      .sort((a, b) => b?.views?.length - a?.views?.length) // sort by view count descending
      .slice(0, 20); // optionally limit to top N
  }, [allCommercialData]);


  useEffect(()=>{
   if(searchValue?.trim()&&Array.isArray(allCommercialData)){
  let filtered=[...allCommercialData]?.filter(
    (i)=>`
    ${i?.name} ${i?.place?.name}
    ${i?.location?.streetAddress}
    ${i?.types?.join(" ")}`.toUpperCase()?.includes(searchValue?.toUpperCase()));
    setFilteredCommercials(filtered);

   }
  },[searchValue])

  return (
    <div>
      <Container fluid>
        <Header title={t("Discover")} />
        <SearchBar  value={searchValue} setValue={setSearchValue} />
        <div className="mt-2rem">
          <ItemsCard2
            firstItems={searchValue?.trim()?[]:placesNear}
            secondItems={searchValue?.trim()?filteredCommercials:mostPopular}
            ComponentForFirstItems={CommercialLgCard}
            ComponetForSecondItems={CommercialSmCard}
            thirdItems={searchValue?.trim()?filteredCommercials:allCommercialData}
            // canAddNew={user?.roles?.[0] === "contributor"}

            onAddClick={() => setAddModalOpen((prev) => !prev)}
          />
        </div>
      </Container>
      <AddCommercialModal isOpen={addModalOpen} setisOpen={setAddModalOpen} />
    </div>
  );
};
export default UserCommercials;
